/**
 * NB Event Queue | Shared functions
 *
 * @copyright 2023 NB Communication Ltd
 *
 */

import data from '../config.json';

// base64 decode
export const base64Decode = str => atob(str);

// base64 encode
export const base64Encode = str => btoa(str);

// Remove local storage
export const clearStorage = keys => keys.forEach(key => localStorage.removeItem(getKey(key)));

// Netlify function request
export const eq = (e, q, cb) => fetch(`${data.queue}/.netlify/functions/eq?e=${e}&q=${base64Encode(JSON.stringify(q))}`)
	.then(response => response.json())
	.then(data => cb ? cb.call(null, data) : console.log(data));

// Shortcut for getting a keyed key
export const getKey = key => `nb-event-queue${key ? `-${key}` : ''}`;

// Get the current timestamp normalised to UTC
export const getNow = () => {
	return + new Date();
};

// Get the actual opening timestamp, including prequeue
export const getOpen = data => data.open - (data.prequeue * 60 * 1000);

// Get and decode a stored base64 encoded timestamp and return as an integer
export const getTimestamp = key => parseInt(base64Decode(localStorage.getItem(getKey(key)) ?? base64Encode(0)));

// Send data to GA4
export const gtagEvent = params => 'gtag' in window ? gtag('event', 'nb_event_queue', params) : null;

// Is the queue active?
export const isActive = (data, ts) => data.open && ts > getOpen(data) && data.close && ts < data.close;
